import { Outlet } from "react-router-dom";
import Header from "./Header";
import Sidebar from "./Sidebar";
import { useSelector } from "react-redux";

const Layout = () => {
  const { sidebarEnabled } = useSelector((state) => state.common);

  // sidebarEnabled=true  → expanded sidebar (~13rem + side margins)
  // sidebarEnabled=false → collapsed icon rail (~5rem + margins)
  const contentOffset = sidebarEnabled
    ? "pl-4 max-md:pl-4 md:pl-64"
    : "pl-4 max-md:pl-4 lg:pl-32";

  return (
    <>
      <div className={`${!sidebarEnabled ? "wrap-toggle" : "no-wraptoggle"}`}>
        <Header />
        <div
          className={`${
            !sidebarEnabled ? "flex max-md:flex-col" : ""
          } main-wrap dark:bg-slate-600`}
        >
          <Sidebar />
          <div
            style={{ height: "calc(100vh - 57px)" }}
            className={`flex w-full content-wrap overflow-y-auto pe-5 bg-gray-200/30 dark:bg-slate-800 ${contentOffset}`}
          >
            <Outlet />
          </div>
        </div>
      </div>
    </>
  );
};

export default Layout;
